import { render, staticRenderFns } from "./NominacionEdit.vue?vue&type=template&id=efd5e892"
import script from "./NominacionEdit.vue?vue&type=script&lang=js"
export * from "./NominacionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports